import Dropdown from '@acorn-portal/shared/src/components/dropdown';
import FormField from '@acorn-portal/shared/src/components/inputs/FormField';
import HelperModal from '@acorn-portal/shared/src/components/modal/HelperModal';
import { Box, Theme, useMediaQuery } from '@mui/material';
import { FC, useState } from 'react';
import { BaseLabel } from './base-label';
import { HiddenDesktopLabel } from './hidden-desktop-label';
import SelectIcon from './icon-button';

interface IModal {
	title: string;
	description: string;
}
export interface IOptions {
	value?: string | number | readonly string[];
	label: string | number;
	[key: string]: string | number | readonly string[] | null | undefined;
}

interface IProps {
	onChange: (value: string) => void;
	name?: string;
	id?: string;
	error?: boolean;
	helperText?: string | false;
	value?: unknown;
	label: string;
	labelVariant?: 'base' | 'desktopHidden';
	modal?: IModal;
	options: IOptions[];
	additionalDriver?: boolean;
	fillWidth?: boolean;
	isDisabled?: boolean;
	helperTextColour?: string;
}

const SelectFormField: FC<IProps> = ({
	error,
	helperText,
	id,
	label = 'base',
	labelVariant,
	modal,
	options,
	name,
	value,
	onChange,
	additionalDriver,
	fillWidth,
	isDisabled = false,
	helperTextColour,
}) => {
	const [open, toggleModal] = useState(false);
	const showModal = () => toggleModal(true);
	const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

	const data =
		options && options.length > 0
			? options.filter((x) => {
					if (!x.hidden && additionalDriver && x.value !== 'P') {
						return x;
					}
					if (!x.hidden && !additionalDriver) {
						return x;
					}
					return undefined;
				})
			: [];

	const generateValue = (x?: unknown) => {
		if (typeof x === 'number') {
			return x.toString();
		}
		return (x as string) || '';
	};

	return (
		<Box>
			<FormField
				error={error}
				helperText={helperText}
				id={id}
				label={
					labelVariant === 'desktopHidden' ? (
						<HiddenDesktopLabel
							id={id ?? ''}
							label={label}
							onIconClick={showModal}
							isMobile={isMobile}
							modal={Boolean(modal)}
						/>
					) : (
						<BaseLabel id={id ?? ''} label={label} onIconClick={showModal} />
					)
				}
				fillWidth={fillWidth}
				helperTextColour={helperTextColour}
			>
				<Dropdown
					error={error}
					data={data}
					id={id}
					name={name}
					label=''
					value={generateValue(value)}
					onChange={(newOption) => {
						onChange(newOption as string);
					}}
					modal={Boolean(modal)}
					isDisabled={isDisabled}
				/>
				{modal && !isMobile && <SelectIcon id={id ?? ''} onClick={showModal} isMobile={isMobile} />}
			</FormField>
			{modal && <HelperModal onClose={() => toggleModal(false)} open={open} {...modal} />}
		</Box>
	);
};

export default SelectFormField;
